'use strict';

import React from 'react';
import moment from 'moment'

import AllocationList from "./AllocationList/AllocationList";
import NewAllocation  from "./NewAllocation/NewAllocation";
import { OnSchedUtils } from "../../../../utils";


const AllocationsForm = ({ element, onschedState }) => {
  const [allocations, setAllocations] = React.useState([]);
  const [newBlock, setNewBlock] = React.useState(false);

  React.useEffect(() => {console.log('allocations', allocations)}, [allocations])

  const addBlock = () => {
    setNewBlock(!newBlock);
    setTimeout(() => {
      let startTime = (parseInt(moment().format('HH')) + 2) > 24 ? 2300 : (parseInt(moment().format('HH')) + 1) * 100;
      let endTime = (parseInt(moment().format('HH')) + 2) > 24 ? 2400 : (parseInt(moment().format('HH')) + 2) * 100;
      const idx = document.getElementsByName('startTime').length - 1;
      
      document.getElementsByName('startDate')[idx].value = moment().format('YYYY-MM-DD');
      document.getElementsByName('endDate')[idx].value = moment().format('YYYY-MM-DD');
      
      document.getElementsByName('startTime')[idx].value = startTime;
      document.getElementsByName('endTime')[idx].value = endTime;
    }, 50);
  }

  return (
    <div className="AllocationsForm">
      <button 
        className="OnSchedBtn" 
        type="button"
        onClick={addBlock}
        disabled={newBlock}
      >
        <i className="fa-light fa-layer-plus"></i>
        {OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_allocations_btn1')}
      </button>
      <span className='form-checkbox-input-detail'>{OnSchedUtils.Internationalize(element, 'setup_locationSetup_form_allocations_btn1_desc')}</span>
      
      <AllocationList 
        element={element}
        allocations={allocations} 
        setAllocations={setAllocations}
        onschedState={onschedState} 
      />
      
      <NewAllocation element={element} allocations={allocations} setAllocations={setAllocations} newBlock={newBlock} setNewBlock={setNewBlock} onschedState={onschedState} />
    </div>
  )
}

export default AllocationsForm
